export default __webpack_public_path__ + "static/vidBg-939f579b22748bf1b244d0bc36799ad4.mp4";